import { Fancybox } from '@fancyapps/ui/dist/fancybox';
import Headroom from 'headroom.js';
// Imported for side effects only: bundles Popper and wires up Bootstrap's
// data-api (dropdowns, collapse, etc.) without needing named bindings.
import '@popperjs/core';
import 'bootstrap';
import shareThis from 'share-this';
import * as facebookSharer from 'share-this/dist/sharers/facebook';
import * as emailSharer from 'share-this/dist/sharers/email';
import * as xSharer from '~/lib/sharers/twitter';
import * as redditSharer from '~/lib/sharers/reddit';
import * as linkedinSharer from '~/lib/sharers/linkedin';
import { l10n } from '~/lib/ui/src/js/fancyapps';

export default () => {

  // ShareThis initialization
  if (!window.matchMedia || !window.matchMedia('(pointer: coarse)').matches) {
    const selectionShare = shareThis({
      selector: 'p',
      sharers: [
        facebookSharer,
        xSharer,
        linkedinSharer,
        redditSharer,
        emailSharer
      ]
    });
    selectionShare.init();
  }

  // Headroom initialization
  try {
    const header = document.querySelector('#stickyhead');
    if (header) {
      const headroom = new Headroom(header, {
        offset: 285,
        tolerance: 5,
        classes: {
          initial: 'animated',
          pinned: 'slideIn',
          unpinned: 'slideOut'
        }
      });
      if (headroom) {
        headroom.init();
      }
    }
  } catch (_err) {}

  // Fancybox initialization
  try {
    Fancybox.bind('[data-fancybox]', {
      ...l10n[window.DOCUMENT_LANG]
        ? {
          l10n: l10n[window.DOCUMENT_LANG]
        }
        : {},
      Hash: false,
      Carousel: {
        ...l10n[window.DOCUMENT_LANG]
          ? {
            l10n: l10n[window.DOCUMENT_LANG]
          }
          : {},
        Thumbs: {
          type: 'classic'
        },
        Toolbar: {
          /* eslint-disable @stylistic/max-len */
          // TODO: custom buttons, e.g. social share buttons:
          // items: {
          //   facebook: {
          //     tpl: '<button class="f-button"><svg><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/></svg></button>',
          //     click: () => {
          //       window.open(
          //         `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
          //           window.location.href
          //         )}&t=${encodeURIComponent(document.title)}`,
          //         '',
          //         'left=0,top=0,width=600,height=300,menubar=no,toolbar=no,resizable=yes,scrollbars=yes'
          //       );
          //     }
          //   }
          // },
          /* eslint-enable @stylistic/max-len */
          display: {
            left: [ 'counter' ],
            right: [
              'zoomIn',
              'zoomOut',
              'toggle1to1',
              'slideshow',
              'thumbs',
              'fullscreen',
              'download',
              'close'
            ]
          }
        }
      }
    });
  } catch (_err) {}
};
